import { ConfigProviderProps } from 'antd/lib/config-provider';

export const getThemeConfig = (): ConfigProviderProps => {
  return {
    theme: {},
  } as ConfigProviderProps;
};
